import { t } from '@lingui/core/macro';
import { TableRowCollapse, TableBodyCell, TableCellText, UserAvatar } from '@pocketlaw/tetris';
import { localizedFormatDate } from 'shared/domains/common-utils';
import { UserRole, DesktopTableBodyCell, DropDownContent, ContextCell } from './components';
import { getTableHeaders } from '../../utils/tableHeaders';
export function UserTableRow(props) {
    const tableHeaders = getTableHeaders();
    const { id, name, email, createdAt, role, isSelf } = props;
    const date = localizedFormatDate(createdAt);
    const deletedUser = t({
        message: 'Deleted user',
        comment: 'Fallback name when user does not exist',
    });
    return (<TableRowCollapse expandibleHeaders={tableHeaders.dropDown.id} colSpan={3} dropdownContent={<DropDownContent role={role} id={id} isSelf={isSelf} createdAt={date || ''}/>} hideDropdownOnBreakpoint="sm">
      <TableBodyCell headers={tableHeaders.name.id}>
        <UserAvatar title={name !== null && name !== void 0 ? name : deletedUser} subtitle={email !== null && email !== void 0 ? email : ''} size="sm"/>
      </TableBodyCell>

      <DesktopTableBodyCell headers={tableHeaders.createdAt.id}>
        <TableCellText primary={date}/>
      </DesktopTableBodyCell>

      <DesktopTableBodyCell headers={tableHeaders.role.id}>
        <UserRole role={role} id={id} isSelf={isSelf}/>
      </DesktopTableBodyCell>

      <ContextCell stickyColumn="right" role={role} id={id} name={name} isSelf={isSelf}/>
    </TableRowCollapse>);
}
